import TrackingDataHelper from './trackingDataHelper';

export default {
  getPropertyData() {
    const {siteDataV2} = window.start;
    const property = {
      site_id: TrackingDataHelper.getSiteObjectData('siteId'),
      channel: TrackingDataHelper.getSiteObjectData('channel'),
      shipping_country_code: TrackingDataHelper.getSiteObjectData('userLocation'),
      subsite: siteDataV2.subSiteCode,
      is_mobile_version: TrackingDataHelper.isMobileLayout(),
      locale: siteDataV2.locale,
    };
    return {property};
  },
};
